import React, { useEffect, useState } from 'react'
import { formatPoints, getDate } from '../../../utils/helper'
import { customerData, sendEmail, transactionRedeem, transactionRefund, voucherPurchase } from '../../auth/auth';
import parse from "html-react-parser";
import StatusPopup from '../../modal/StatusPopup';
import Loader from '../../partial/Loader';

const RedeemRewardModal = ({ showPopup, setShowPopup, setPopupReward, popupReward, setWalletsDetail, handleSelect }) => {
    const [loader, setLoader] = useState(false)
    const [quantity, setQuantity] = useState(1);
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [statusData, setStatusData] = useState({
        icon: "",
        title: "",
        showStatusPopup: false
    });
    const pointsPerVoucher = popupReward?.voucherValue * 100 || 0;
    const totalPoints = pointsPerVoucher * quantity;
    const maxQuantity = Math.floor(
        parseInt(popupReward?.availablePoints) / parseInt(pointsPerVoucher)
    );

    const isMobileValid = /^[1-9]\d{9}$/.test(mobile);
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isFormValid = isMobileValid && isEmailValid;
    const customerid = localStorage.getItem("customerid");

    const handleIncrease = () => {
        if (quantity < maxQuantity) {
            setQuantity(prev => prev + 1);
        }
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            setQuantity(prev => prev - 1);
        }
    };

    const handleRedemption = async () => {
        try {
            setLoader(true);

            const customerCode = localStorage.getItem("customercode");
            const token = JSON.parse(localStorage.getItem("token_gen"));

            let allSuccess = true;

            for (let i = 0; i < quantity; i++) {
                try {
                    const redeemBody = {
                        customer: {
                            customercode: customerCode,
                        },
                        redeemDetail: {
                            walletType: "point",
                            values: parseInt(popupReward.voucherValue) * 100,
                            transactionType: "redeem",
                            transactionDate: getDate(new Date(), "YYYY-MM-DD"),
                            voucherRedeemDetails: {
                                name: popupReward?.name,
                                voucherValue: popupReward?.voucherValue,
                                redeemedPoints: parseInt(popupReward.voucherValue * 100),
                                transactionDate: getDate(new Date(), "YYYY-MM-DD"),
                            },
                        },
                    };

                    const redeemRes = await transactionRedeem(token, redeemBody);

                    if (redeemRes?.message !== "Request processed successfully.") {
                        handleStatusPopup("error", redeemRes?.message);
                        allSuccess = false;
                        break;
                    }

                    const voucherBody = {
                        voucherTemplateCode: popupReward?.code,
                        merchantId: popupReward?.merchantId[0],
                        customerCode: customerCode,
                        value: parseInt(popupReward.voucherValue * 100),
                        amount: parseInt(popupReward.voucherValue),
                        RedeemTransactionId: redeemRes.data.currentTransactionId,
                    };

                    const voucherRes = await voucherPurchase(token, voucherBody);

                    if (voucherRes?.message !== "Request processed successfully.") {
                        const refundBody = {
                            customer: {
                                customercode: customerCode,
                            },
                            transactionId: redeemRes?.data?.currentTransactionId,
                            transactionAmount: 0,
                            transactionDate: getDate(new Date(), "YYYY-MM-DD"),
                        };

                        await transactionRefund(token, refundBody);

                        handleStatusPopup("error", "Voucher purchase failed, amount refunded");
                        allSuccess = false;
                        break;
                    }

                } catch (err) {
                    allSuccess = false;
                    handleStatusPopup("error", "Something went wrong");
                    break;
                }
            }

            if (allSuccess) {
                const customerEmailBody = {
                    "toEmail": email,
                    "subject": "Progcap - Voucher Purchase",
                    "body": `<!DOCTYPE html>
                                    <html lang="en">
                                    <head>
                                    <meta charset="UTF-8">
                                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                    <title>Progcap - Voucher Purchase</title>
                                    </head>

                                    <body style="margin:0; padding:0; background:#f4f4f4; font-family:Arial, sans-serif;">

                                    <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
                                    <tr>
                                    <td align="center">

                                    <table width="600" style="background:#ffffff; padding:30px; border-radius:8px;">

                                    <tr>
                                    <td align="center">
                                    <h2 style="color:#2c3e50;">Progcap</h2>
                                    <p style="color:#888;">Voucher Purchase Confirmation</p>
                                    </td>
                                    </tr>

                                    <tr>
                                    <td style="color:#333; font-size:14px; line-height:22px;">

                                    <p>Hello ${localStorage.getItem("name")},</p>

                                    <p>
                                    Thank you for purchasing a voucher with <b>Progcap</b>.
                                    </p>

                                    <p>
                                    Our <b>Progcap Team</b> will connect with you soon regarding your voucher.
                                    </p>

                                    <table width="100%" style="margin-top:20px; border-collapse:collapse;">

                                    <tr>
                                    <td><b>Voucher Name</b></td>
                                    <td>${popupReward?.name}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Voucher Quantity</b></td>
                                    <td>${quantity}</td>
                                    </tr>

                                   <tr>
                                    <td><b>Redeemed Points</b></td>
                                    <td>${formatPoints(popupReward?.voucherValue * quantity * 100)}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Purchase Date</b></td>
                                    <td>${getDate(new Date(), "DD-MM-YYYY")}</td>
                                    </tr>

                                    </table>

                                    <p style="margin-top:20px;">
                                    We appreciate your purchase and look forward to serving you.
                                    </p>

                                    <p>
                                    Regards,<br>
                                    <b>Progcap Team</b>
                                    </p>

                                    </td>
                                    </tr>

                                    <tr>
                                    </tr>

                                    </table>

                                    </td>
                                    </tr>
                                    </table>

                                    </body>
                                    </html>`
                }

                const adminEmailBody = {
                    "toEmail": "monika.kumari@progcap.com",
                    "subject": "Progcap - Voucher Purchase",
                    "body": `<!DOCTYPE html>
                                    <html lang="en">
                                    <head>
                                    <meta charset="UTF-8">
                                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                    <title>Voucher Purchase Alert</title>
                                    </head>

                                    <body style="margin:0; padding:0; background:#f4f4f4; font-family:Arial, sans-serif;">

                                    <table width="100%" cellpadding="0" cellspacing="0" style="padding:20px;">
                                    <tr>
                                    <td align="center">

                                    <table width="600" style="background:#ffffff; padding:30px; border-radius:8px;">

                                    <tr>
                                    <td align="center">
                                    <h2 style="color:#2c3e50;">Voucher Purchase Alert</h2>
                                    <p style="color:#888;">Progcap Notification</p>
                                    </td>
                                    </tr>

                                    <tr>
                                    <td style="color:#333; font-size:14px; line-height:22px;">

                                    <p>Hello Admin,</p>

                                    <p>
                                    A new voucher has been purchased. Below are the details:
                                    </p>

                                    <h3 style="margin-top:20px;">Customer Details</h3>

                                    <table width="100%" style="border-collapse:collapse;">

                                    <tr>
                                    <td><b>Name</b></td>
                                    <td> ${localStorage.getItem("name")}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Email</b></td>
                                    <td>${email}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Phone</b></td>
                                    <td>${mobile}</td>
                                    </tr>

                                    </table>

                                    <h3 style="margin-top:20px;">Voucher Details</h3>

                                    <table width="100%" style="border-collapse:collapse;">

                                    <tr>
                                    <td><b>Voucher Name</b></td>
                                    <td>${popupReward?.name}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Voucher Quantity</b></td>
                                    <td>${quantity}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Redeemed Points</b></td>
                                    <td>${formatPoints(popupReward?.voucherValue * quantity * 100)}</td>
                                    </tr>

                                    <tr>
                                    <td><b>Purchase Date</b></td>
                                    <td>${getDate(new Date(), "DD-MM-YYYY")}</td>
                                    </tr>

                                    </table>

                                    <p style="margin-top:20px;">
                                    Please take the necessary action.
                                    </p>

                                    <p>
                                    Regards,<br>
                                    <b>Progcap System</b>
                                    </p>

                                    </td>
                                    </tr>

                                    </table>

                                    </td>
                                    </tr>
                                    </table>

                                    </body>
                                    </html>`
                }

                const promises = [
                    sendEmail(token, customerEmailBody),
                    sendEmail(token, adminEmailBody),
                ];

                if (setWalletsDetail) {
                    promises.push(customerData(token, customerCode, 1, 0));
                }

                const results = await Promise.all(promises);

                if (setWalletsDetail) {
                    const customerRes = results[results.length - 1];
                    setWalletsDetail(customerRes?.walletsDetail);
                }

                handleStatusPopup(
                    "success",
                    "Your voucher has been successfully purchased. A confirmation email has been sent."
                );
            }

            setPopupReward(false);

        } catch (err) {
            handleStatusPopup("error", err.message);
        } finally {
            setEmail("");
            setMobile("");
            setQuantity(1);
            setLoader(false);
            setShowPopup(false);
        }
    };

    const handleStatusPopup = (icon, title) => {
        setStatusData((prev) => ({
            ...prev,
            icon: icon,
            title: title,
            showStatusPopup: true
        }))
    };

    return (

        <>
            {loader && <Loader />}
            <div>
                {showPopup && popupReward && (
                    <div className="popup show">
                        <div className="popup-box reward-box">

                            <span
                                className="close-popup"
                                onClick={() => {
                                    setShowPopup(false)
                                    setEmail("")
                                    setMobile("")
                                    setQuantity(1)
                                }}
                            >
                                ✕
                            </span>

                            <div className="modal-scroll">

                                {popupReward.isUnlocked ? (
                                    <div className="redeem-modal">
                                        <h3 className="modal-title">Redeem Reward</h3>

                                        <div className="redeem-header">
                                            <img
                                                src={popupReward?.imageUpload}
                                                alt={popupReward?.name}
                                                className="redeem-image"
                                            />
                                            <div>
                                                <h4>{popupReward.name}</h4>
                                                <p className="points-purple">
                                                    {formatPoints(popupReward.voucherValue * 100)} Points / voucher
                                                </p>
                                            </div>
                                        </div>

                                        <div className="points-box">

                                            <div className="points-row">
                                                <span className="points-title">Available Points</span>
                                                <span className="points-value">{formatPoints(popupReward?.availablePoints)}</span>
                                            </div>

                                            <div className="points-row">
                                                <span className="points-title">Points to be Used</span>
                                                <span className="points-value">
                                                    {formatPoints(totalPoints)}
                                                </span>
                                            </div>

                                        </div>

                                        <div className="quantity-section">
                                            <label>Voucher Quantity</label>
                                            <div className="quantity-controls">
                                                <button
                                                    onClick={handleDecrease}
                                                    disabled={quantity === 1}
                                                >
                                                    -
                                                </button>

                                                <span>{quantity}</span>

                                                <button
                                                    onClick={handleIncrease}
                                                    disabled={quantity === maxQuantity}
                                                >
                                                    +
                                                </button>

                                                <span className="max-text">Max: {maxQuantity}</span>
                                            </div>
                                        </div>

                                        <div className="input-group">
                                            <label>Mobile Number</label>
                                            <input
                                                type="text"
                                                value={mobile}
                                                onChange={(e) => setMobile(e.target.value)}
                                                placeholder="Enter 10-digit mobile number"
                                                maxLength={10}
                                            />
                                            {!isMobileValid && mobile.length > 0 && (
                                                <small className="error-text">Enter valid mobile number</small>
                                            )}
                                        </div>

                                        <div className="input-group">
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Enter your email address"
                                            />
                                            {!isEmailValid && email.length > 0 && (
                                                <small className="error-text">Enter valid email address</small>
                                            )}
                                        </div>

                                        <div className="info-box">
                                            <span className="info-icon">!</span>
                                            <p>
                                                Once you raise the request, your <strong>service manager</strong> will reach out to you and share the voucher details on your registered mobile & email.
                                            </p>
                                        </div>

                                        <button
                                            className="confirm-btn"
                                            disabled={!isFormValid || loader}
                                            onClick={() => {
                                                handleRedemption()
                                            }}
                                        >
                                            Confirm Redemption • {formatPoints(totalPoints)} pts
                                        </button>

                                    </div>
                                ) : (
                                    <div className="popup-box-inner popup-box-inner-no-pd">
                                        <h3>{(popupReward?.name)}</h3>
                                        <p>
                                            {(popupReward?.description && parse(popupReward?.description))}
                                            {/* {formatRewardContent(popupReward.description)} */}
                                        </p>

                                        <p className="points no-mar">
                                            {formatPoints(
                                                popupReward?.voucherValue * 100
                                            )} Points Required
                                        </p>
                                        {!setWalletsDetail && customerid === "13217511" && (
                                            <button
                                                className='btn btn-primary btn-full'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleSelect(
                                                        popupReward,
                                                    );
                                                }}>
                                                Select Reward
                                            </button>)}
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                )}
            </div>
            <StatusPopup
                showStatusPopup={statusData.showStatusPopup}
                setStatusData={setStatusData}
                icon={statusData.icon}
                title={statusData.title}
            />
        </>
    )
}

export default RedeemRewardModal
